export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        logGridIsOpen: false,
        wikiIsOpen: false,

        dataTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-info"></i> WIKI',
                event_name: "customClick",
                class: "btn btn-info",
                event_payload: 'openWiki'
            },
            {
                btn_text: '<i class="fas fa-file-download"></i> Minta Excel letöltése',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'downloadTemplate'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új Excel feltöltése',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-check"></i> Adatellenőrzés',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'validateXls',
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyXls',
                additionalButtonVisible: 'xlsImportModifyXlsButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-file-import"></i>',
                event_name: "customClick",
                title: "Betöltés",
                class: "btn btn-outline-success",
                event_payload: 'importXls',
                additionalButtonVisible: 'xlsImportImportXlsButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-align-justify"></i>',
                title: "Log megtekintése",
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'showLoaderLog',
                additionalButtonVisible: 'xlsImportShowXlsLogButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: "Visszavonás",
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'rollbackXls',
                additionalButtonVisible: 'xlsImportRollbackXlsButtonVisible'
            }
        ],
        searchFields: [
            {
                name: "fileName",
                label: "Fájlnév",
                formType: "text",
                formVisible: true,
                formSize: 4
            },
            {
                name: "uploader",
                label: "Feltöltő",
                formType: "text",
                formVisible: true,
                formSize: 4
            },
            {
                name: "fromDate",
                label: "Feltöltés idejétől",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "toDate",
                label: "Feltöltés idejéig",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Feltöltési azonosító",
                visibility: true
            },
            {
                name: "logText",
                label: "Fájlnév",
                visibility: true
            },
            {
                name: "fileData",
                label: "Feltöltés...",
                formType: "xlsFileInput",
                fileSize: "1024",
                formRequired: true,
                formSize: 4,
                visibility: false,
                formVisible: true,
            },
            {
                name: "email",
                label: "E-mail",
                enableCopy: true,
                formRequired: true,
                formType: "email",
                formSize: 4,
                formVisible: true,
                visibility: false
            },
            {
                name: "createdBy",
                label: "Feltöltő",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Feltöltés ideje",
                visibility: true,
                slot_name: "datetime_format"
            }
        ],
        logActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToXlsGrid'
            }
        ],
        logHeaderFields: [
            {
                name: "logText",
                label: "Betöltött Xls tartalma",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Dátum",
                visibility: true,
                slot_name: "created_on_format"
            }
        ]
    }
}
